import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask'
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule  } from 'ngx-google-analytics';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslatorPipe } from './pipes/root-translator.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginChatNavComponent } from './components/login-chat-nav/login-chat-nav.component';
import { HomeComponent } from './components/home/home.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { SignupComponent } from './components/signup/signup.component';
import { AWelcomeComponent } from './components/signup/a-welcome/a-welcome.component';
import { BStartComponent } from './components/signup/b-start/b-start.component';
import { CStartMAHComponent } from './components/signup/c-start-mah/c-start-mah.component';
import { CStartISPComponent } from './components/signup/c-start-isp/c-start-isp.component';
import { CNotSureComponent } from './components/signup/c-not-sure/c-not-sure.component';
import { DCompanyNameComponent } from './components/signup/d-company-name/d-company-name.component';
import { ECompanyInfoComponent } from './components/signup/e-company-info/e-company-info.component';
import { FCompanyMACTransComponent } from './components/signup/f-company-mactrans/f-company-mactrans.component';
import { ECompanyInfoISPComponent } from './components/signup/e-company-info-isp/e-company-info-isp.component';
import { FCompanyInfoISPComponent } from './components/signup/f-company-info-isp/f-company-info-isp.component';
import { FCompanyInfoMahComponent } from './components/signup/f-company-info-mah/f-company-info-mah.component';
import { GCompnayFeesComponent } from './components/signup/g-compnay-fees/g-compnay-fees.component';
import { HUserAccessComponent } from './components/signup/h-user-access/h-user-access.component';
import { IUserAccessContactComponent } from './components/signup/i-user-access-contact/i-user-access-contact.component';
import { JUserAccessUserInfoComponent } from './components/signup/j-user-access-user-info/j-user-access-user-info.component';
import { KReviewComponent } from './components/signup/k-review/k-review.component';
import { LReviewUserComponent } from './components/signup/l-review-user/l-review-user.component';
import { MHowComponent } from './components/signup/m-how/m-how.component';
import { NTACComponent } from './components/signup/n-tac/n-tac.component';
import { OCERTComponent } from './components/signup/o-cert/o-cert.component';
import { PDisclosureAndAuthComponent } from './components/signup/p-disclosure-and-auth/p-disclosure-and-auth.component';
import { QCreatePaymentComponent } from './components/signup/q-create-payment/q-create-payment.component';
import { RAchCardPaymentComponent } from './components/signup/r-ach-card-payment/r-ach-card-payment.component';
import { SAllDoneGoodComponent } from './components/signup/s-all-done-good/s-all-done-good.component';
import { SAllDoneErrorComponent } from './components/signup/s-all-done-error/s-all-done-error.component';

import { ProgressWizardComponent } from './components/parts/progress-wizard/progress-wizard.component';
import { CompleteBarComponent } from './components/parts/complete-bar/complete-bar.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { TermsandconditionsComponent } from './components/termsandconditions/termsandconditions.component';
import { VeteransComponent } from './components/veterans/veterans.component';
import { WomenDriversComponent } from './components/women-drivers/women-drivers.component';
import { AccessdeniedComponent } from './components/accessdenied/accessdenied.component';
import { DashboardgridComponent } from './components/dashboardgrid/dashboardgrid.component';
import { AgGridModule } from 'ag-grid-angular';
import { CelllinkrendererComponent } from './components/cellrenderers/celllinkrenderer/celllinkrenderer/celllinkrenderer.component';
import { ContactComponent } from './components/contact/contact.component';
import { ContactFormComponent } from './components/parts/contact-form/contact-form.component';
import { FAQsComponent } from './components/faqs/faqs.component';
import { ActivityComponent } from './components/invoice/activity/activity.component';
import { BillingReportsComponent } from './components/billing-reports/billing-reports.component';
import { InvoiceComponent } from './components/invoice/invoice.component';
import { ByauthcodeComponent } from './components/byauthcode/byauthcode.component';
import { CustomercellbuttonrendererComponent } from './components/cellrenderers/customercellbuttonrenderer/customercellbuttonrenderer/customercellbuttonrenderer.component';
import { DashboardgridsearchComponent } from './components/dashboardgridsearch/dashboardgridsearch.component';
import { DashboardnewsComponent } from './components/dashboardnews/dashboardnews.component';
import { DashboardsupportComponent } from './components/dashboardsupport/dashboardsupport.component';
import { RequestrecordsComponent } from './components/requestrecords/requestrecords.component';
import { WSAPIComponent } from './components/WSToken/wsapi/wsapi.component';
import { WSTokenComponent } from './components/WSToken/wstoken/wstoken.component';
import { BillingSummaryComponent } from './components/billing-reports/billing-summary/billing-summary.component';
import { GenericStatementComponent } from './components/billing-reports/generic-statement/generic-statement.component';
import { SinglePaperInvoiceComponent } from './components/billing-reports/single-paper-invoice/single-paper-invoice.component';
import { NewsComponent } from './components/news/news.component';
import { DriversComponent } from './components/drivers/drivers.component';
import { ProbationOrderSuccessComponent } from './components/probation-order-success/probation-order-success.component';
import { ApplicationexceptionComponent } from './components/applicationexception/applicationexception.component';
import { httpInterceptorProviders } from './helpers/httpInterceptor';
import { AuditAcknowledgementComponent } from './components/audit/audit-acknowledgement/audit-acknowledgement.component';
import { AuditDashboardComponent } from './components/audit/audit-dashboard/audit-dashboard.component';
import { LuxonModule } from 'luxon-angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { DriverComponent } from './components/driver/driver.component';
import { StartComponent } from './components/driver/a-start/start.component';
import { DisclaimersComponent } from './components/driver/b-disclaimers/disclaimers.component';
import { ContactInfoComponent } from './components/driver/c-contact-info/contact-info.component';
import { EmailComponent } from './components/driver/d-email/email.component';
import { AddressComponent } from './components/driver/e-address/address.component';
import { LicenseComponent } from './components/driver/f-license/license.component';
import { ReviewComponent } from './components/driver/g-review/review.component';
import { BillingAddressComponent } from './components/driver/h-billing-address/billing-address.component';
import { IdQuizComponent } from './components/driver/i-id-quiz/id-quiz.component';
import { OrderSuccessComponent } from './components/driver/j-order-success/order-success.component';
import { OrderFailComponent } from './components/driver/k-order-fail/order-fail.component';
import { IdVerifyFailComponent } from './components/driver/l-id-verify-fail/id-verify-fail.component';
import { CustomerSupportInfoComponent } from './components/customer-support-info/customer-support-info.component';
import { UserAccountAdminComponent } from './components/user-account-admin/user-account-admin.component';
import { EditUserComponent } from './components/UserAccountAdmin/edit-user/edit-user.component';
import { WrongRouteComponent } from './components/wrong-route/wrong-route.component';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { MangagePaymentMethodsComponent } from './components/mangage-payment-methods/mangage-payment-methods.component';
import { MethodsComponent } from './components/mangage-payment-methods/methods/methods.component';
import { DriverDashboardComponent } from './components/driver-dashboard/driver-dashboard.component';
import { DriverDashboardGridComponent } from './components/driver-dashboard-grid/driver-dashboard-grid.component';
import { DriverMonitorSettingsComponent } from './components/driver-monitor-settings/driver-monitor-settings.component';
import { CellTwoButtonRendererComponent } from './components/cellrenderers/cell-two-button-renderer/cell-two-button-renderer.component';
import { SigninComponent } from './components/signin/signin.component';
import { ByAuthCodeRedirectComponent } from './components/by-auth-code-redirect/by-auth-code-redirect.component';
import { environment } from 'src/environments/environment';
import { MvrByStateComponent } from './components/mvr-by-state/mvr-by-state.component';
import { SubscribedComponent } from './components/driver/subscribed/subscribed.component';
import { ScrollToTopComponent } from './components/scroll-to-top/scroll-to-top.component';

@NgModule({ declarations: [
        AppComponent,
        TranslatorPipe,
        LoginChatNavComponent,
        HomeComponent,
        SignupComponent,
        AWelcomeComponent,
        BStartComponent,
        CStartMAHComponent,
        CStartISPComponent,
        CNotSureComponent,
        DCompanyNameComponent,
        ECompanyInfoComponent,
        FCompanyMACTransComponent,
        ECompanyInfoISPComponent,
        FCompanyInfoISPComponent,
        FCompanyInfoMahComponent,
        GCompnayFeesComponent,
        HUserAccessComponent,
        IUserAccessContactComponent,
        JUserAccessUserInfoComponent,
        KReviewComponent,
        LReviewUserComponent,
        MHowComponent,
        NTACComponent,
        OCERTComponent,
        PDisclosureAndAuthComponent,
        QCreatePaymentComponent,
        RAchCardPaymentComponent,
        SAllDoneGoodComponent,
        SAllDoneErrorComponent,
        ProgressWizardComponent,
        CompleteBarComponent,
        DashboardComponent,
        TermsandconditionsComponent,
        VeteransComponent,
        WomenDriversComponent,
        AccessdeniedComponent,
        DashboardgridComponent,
        CelllinkrendererComponent,
        ContactComponent,
        ContactFormComponent,
        FAQsComponent,
        ActivityComponent,
        BillingReportsComponent,
        InvoiceComponent,
        ByauthcodeComponent,
        CustomercellbuttonrendererComponent,
        DashboardgridsearchComponent,
        DashboardnewsComponent,
        DashboardsupportComponent,
        RequestrecordsComponent,
        WSAPIComponent,
        WSTokenComponent,
        BillingSummaryComponent,
        GenericStatementComponent,
        SinglePaperInvoiceComponent,
        NewsComponent,
        DriversComponent,
        ProbationOrderSuccessComponent,
        ApplicationexceptionComponent,
        AuditAcknowledgementComponent,
        AuditDashboardComponent,
        DriverComponent,
        StartComponent,
        DisclaimersComponent,
        ContactInfoComponent,
        EmailComponent,
        AddressComponent,
        LicenseComponent,
        ReviewComponent,
        BillingAddressComponent,
        IdQuizComponent,
        OrderSuccessComponent,
        OrderFailComponent,
        IdVerifyFailComponent,
        CustomerSupportInfoComponent,
        UserAccountAdminComponent,
        EditUserComponent,
        WrongRouteComponent,
        MangagePaymentMethodsComponent,
        MethodsComponent,
        DriverDashboardComponent,
        DriverDashboardGridComponent,
        DriverMonitorSettingsComponent,
        CellTwoButtonRendererComponent,
        SigninComponent,
        ByAuthCodeRedirectComponent,
        MvrByStateComponent,
        SubscribedComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        NgbDropdownModule,
        NgbAlert,
        ReactiveFormsModule,
        NgxMaskDirective,
        NgxMaskPipe,
        AgGridModule,
        LuxonModule,
        NgxGoogleAnalyticsModule.forRoot(environment.APP_GA4_MEASUREMENT_ID),
        NgxGoogleAnalyticsRouterModule,
        ScrollToTopComponent], providers: [
        httpInterceptorProviders,
        provideNgxMask(),
        NgbActiveModal,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
